import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { CfetPageNamesConstant, CfetBaseComponent } from '../../cfet-core';

@Component({
    selector: 'app-session-time-out',
    templateUrl: './session-time-out.component.html',
    styleUrls: ['./session-time-out.component.scss'],
    standalone: false
})
export class SessionTimeOutComponent extends CfetBaseComponent implements OnInit {

  constructor(private router: Router,
    private title: Title) { super(); }

  ngOnInit () {
    this.title.setTitle(this.cfetTitles.timeout.htmlTitle);
    window.scroll(0, 0);
  }

  restart (event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.router.navigate([CfetPageNamesConstant.CUSTOMER_LANDING]);
    }
  }

}
